/* Form utils */
const FORM_STATUS = {
  LOADING: "LOADING",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
  NOT_FOUND: "NOT_FOUND"
}

export { FORM_STATUS };